module.exports = __webpack_public_path__ + "img/hero2.b785160a.jpg";